export default __webpack_public_path__ + "static/media/001-M-celibataire.695ab1b8.svg";